import * as ngCore from '@angular/core'

import * as input from '../../input'
import * as data from '../data'
import { Store } from '../store'

import * as pagination from './pagination'

/** Composes controlled table controls around the data viewport. */
@ngCore.Component({
  imports: [data.Component, input.search.Component, pagination.Component],
  selector: 'atn-ds-table-content',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** Shared table state used by the template. */
  public readonly store = ngCore.inject(Store)
}
